import { Icon } from "../../../core/components/ui/icon";

interface QuickActionsProps {
  phone?: string | null;
  email?: string | null;
  /** Adresse postale complète : ouvre l'itinéraire dans l'application de cartes. */
  address?: string | null;
  /** « sm » : boutons compacts (rangées de liste). */
  size?: "md" | "sm";
}

/** Numéro composable : chiffres et « + » seulement. */
export function telHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, "")}`;
}

export function smsHref(phone: string): string {
  return `sms:${phone.replace(/[^\d+]/g, "")}`;
}

export function mapsHref(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

/**
 * Appeler, texter, écrire, s'y rendre : les quatre gestes qu'un technicien
 * fait avec un client, en un tap depuis n'importe quelle fiche. Ce sont de
 * vrais liens (`tel:`, `sms:`, `mailto:`, cartes) : la tablette ouvre
 * l'application qu'il faut, rien ne transite par le serveur.
 */
export function QuickActions({ phone, email, address, size = "md" }: QuickActionsProps) {
  const cls = `quick-actions${size === "sm" ? " quick-actions--sm" : ""}`;
  const items: Array<{
    key: string;
    href: string;
    label: string;
    icon: "phone" | "sms" | "mail" | "map-pin";
  }> = [];
  if (phone) {
    items.push({ key: "tel", href: telHref(phone), label: "Appeler", icon: "phone" });
    items.push({ key: "sms", href: smsHref(phone), label: "Texto", icon: "sms" });
  }
  if (email) items.push({ key: "mail", href: `mailto:${email}`, label: "Courriel", icon: "mail" });
  if (address)
    items.push({ key: "map", href: mapsHref(address), label: "Itinéraire", icon: "map-pin" });
  if (items.length === 0) return null;
  return (
    <div className={cls} role="group" aria-label="Joindre le client">
      {items.map((it) => (
        <a
          key={it.key}
          className="quick-actions__btn"
          href={it.href}
          target={it.key === "map" ? "_blank" : undefined}
          rel={it.key === "map" ? "noreferrer" : undefined}
          aria-label={it.label}
          title={it.label}
          onClick={(e) => e.stopPropagation()}
        >
          <Icon name={it.icon} size={size === "sm" ? 16 : 18} />
          <span className="quick-actions__label">{it.label}</span>
        </a>
      ))}
    </div>
  );
}
